module.exports = __webpack_public_path__ + "img/logo-comeup-jaune.5f1384cb.webp";